module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Tipo do módulo",
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expediter.type),
      expression: "expediter.type"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.expediter, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onChangeExpediterType]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.expediters), function(expediter) {
    return _c('option', {
      key: expediter,
      domProps: {
        "value": expediter.type
      }
    }, [_vm._v(_vm._s(_vm.$t(expediter.type).label))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define com qual tipo de sistema os pedidos do marketplace devem ser sincronizados.")])]), _vm._v(" "), (_vm.expediter.type && _vm.expediter.type !== 'null') ? _c('form-group', {
    attrs: {
      "label": "Nome do módulo",
      "required": _vm.isRequired
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expediter.identifier),
      expression: "expediter.identifier"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.expediter, "identifier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.identifiers), function(expediterIdentifier) {
    return _c('option', {
      key: expediterIdentifier,
      domProps: {
        "value": expediterIdentifier
      }
    }, [_vm._v(_vm._s(_vm.$t(expediterIdentifier).label))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define com qual sistema os pedidos do marketplace devem ser sincronizados.")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-113ab154","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shared/ExpediterConfiguration.vue
// module id = 2915
// module chunks = 0